<template >
  <div class="form-group mb-0">
    <label for="bonusCode" class="form-control-label">
      {{ __('bonus_code_title') }}
    </label>
    <div class="flex">
      <template v-if="bonusCode && isBonusCodeValid">
        <input
            type="text"
            id="bonusCode"
            class="form-control"
            disabled
            :value="bonusCode"
        />
        <Button
            styleType="secondary"
            :loading="loading"
            :disabled="locked"
            @click="removeCode"
        >
          {{ __('btn_remove') }}
        </Button>
      </template>
      <template v-else>
        <input
            type="text"
            id="bonusCode"
            :placeholder="__('form.insert_bonus_code_title')"
            class="form-control"
            :disabled="locked"
            v-model="bonusCodeValue"
        />
        <Button
            styleType="secondary"
            :loading="loading"
            :disabled="locked"
            @click="updateCode"
        >
          {{ __('btn_use') }}
        </Button>
      </template>
    </div>
    <div class="text-red mt-2" v-if="bonusCode && !isBonusCodeValid">
      {{ __('bonus_code_not_found', {code: bonusCode}) }}
    </div>
  </div>
</template>

<script>
import {
  bonusCode,
  isBonusCodeValid,
  removeBonusCode,
  updateBonusCode,
} from '@/stores/bonusCode'
import Button from '@/components/Button'
import {ref} from 'vue'

export default {
  components: {
    Button,
  },
  props: {
    locked: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const bonusCodeValue = ref(bonusCode.value)
    const loading = ref(false)

    const updateCode = async () => {
      loading.value = true
      await updateBonusCode(bonusCodeValue.value)
      loading.value = false
    }

    const removeCode = async () => {
      loading.value = true
      await removeBonusCode()
      bonusCodeValue.value = ''
      loading.value = false
    }

    return {
      bonusCode,
      isBonusCodeValid,
      bonusCodeValue,
      updateCode,
      removeCode,
      loading,
    }
  },
}
</script>
